<template>
  <Doughnut :data="chartData" :options="chartOptions"></Doughnut>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { Doughnut } from "vue-chartjs"
  import {
    Chart as ChartJS,
    Tooltip,
    Legend,
    LayoutPosition,
    ArcElement,
    ChartData,
    ChartOptions,
    Title,
  } from "chart.js"
  import { useThemeHelper } from "@/theme/themeHelper"
  ChartJS.register(Tooltip, Legend, Title, ArcElement)
  export default defineComponent({
    components: {
      Doughnut,
    },
    props: {
      dataSet: {
        type: Array as PropType<number[]>,
        required: true,
        default: () => [],
      },
      labels: {
        type: Array as PropType<string[]>,
        required: true,
        default: () => [],
      },
      backgroundColors: {
        type: Array as PropType<string[]>,
        required: false,
        default: () => [],
      },
      legendPosition: {
        type: String as PropType<LayoutPosition>,
        required: false,
        default: "right",
      },
    },
    data() {
      return {
        currentTheme: useThemeHelper(),
      }
    },
    computed: {
      chartData() {
        const chartData: ChartData<"doughnut"> = {
          labels: this.labels,
          datasets: [
            {
              data: this.dataSet,
              backgroundColor: this.backgroundColors,
              borderWidth: 0,
            },
          ],
        }
        return chartData
      },
      chartOptions() {
        const chartOptions: ChartOptions<"doughnut"> = {
          color: this.currentTheme.colors["on-background"],
          plugins: {
            legend: {
              fullSize: true,
              position: this.legendPosition,
            },
          },
        }
        return chartOptions
      },
    },
  })
</script>
